import { isTablet } from "react-device-detect";
export default function px2rem(pxValue, toRem = true) {
    // toRem为false时，不进行rem转换, 使用原尺寸
    if (!toRem) {
        return pxValue;
    }
    if (typeof window !== 'undefined' && window.templateName === 'search') {
        // 搜索模板根据设备类型进行等比缩放
        if (!isTablet) {
            const ratio = 37.5; // 根据项目配置比例的方式自行设定
            // 针对template literals
            if (Array.isArray(pxValue)) {
                pxValue = pxValue[0];
            }
            if(pxValue.indexOf('%') !== -1) {
                return pxValue;
            }
            pxValue = parseInt(pxValue, 10);
            return pxValue / ratio + 'rem';
        } else {
            // 平板设备不进行等比缩放，使用原尺寸
            return pxValue;
        }
    } else {
        // 其他模板全量等比缩放
        const ratio = 37.5; // 根据项目配置比例的方式自行设定
        // 针对template literals
        if (Array.isArray(pxValue)) {
            pxValue = pxValue[0];
        }
        if(pxValue.indexOf('%') !== -1) {
            return pxValue;
        }
        pxValue = parseInt(pxValue, 10);
        return pxValue / ratio + 'rem';
    }
}


// WEBPACK FOOTER //
// ./utils/px2rem.js